<div tabindex="0"
  role="dialog"
  aria-labelledby="dialogTitle"
  data-automation-id="facet-modal-content">

  <div class="modal-container">
    <div class="close-button-field">
      <button class="close-btn"
        (click)="activeModal.close()"
        aria-label="Close dialog"
        data-automation-id="facet-modal-close-btn">
        <span class="icon-close"></span>
      </button>
    </div>

    <h2 id="dialogTitle" class="title" data-automation-id="facet-modal-title">
      {{ context.facetSchema.pluralName.toLocaleLowerCase() | translate }} ({{ context.facetResult.totalResults }})
    </h2>
    <ng-container>
      <div data-automation-id="facet-modal-search-bar" class="search-input-container">
        <input
          attr.placeholder="{{'Search' | translate}} {{context.facetSchema.pluralName.toLowerCase() | translate}}"
          attr.aria-label="{{'Search' | translate}} {{context.facetSchema.pluralName.toLowerCase() | translate}}"
          class="search-input"
          (keyup.enter)="$event.preventDefault(); onSearch()"
          [formControl]="inputControl"
          cdkFocusInitial ngbAutofocus/>
        <button
          data-automation-id="facet-modal-search-button"
          aria-label="Search"
          disableRipple
          class="search-btn"
          (debounceClick)="onSearch()">
          <span class="btn icon-search icon-search-item" data-automation-id="search-facet-btn"></span>
        </button>
      </div>
    </ng-container>
    <perfect-scrollbar style="max-height: 600px" removeTabindexOnYScroll>
      <div class="scrollable-content">
        <div class="wrapper">
          <div class="content">
            <button
              data-automation-id="facet-modal-reset-filters"
              (click)="resetFilters()"
              class="ins-buttons button-secondary flint reset-btn">
              {{ 'resetFiltersButton' | translate }}
              <ng-container *ngIf="selectedFacets.length > 0">({{selectedFacets.length}})</ng-container>
            </button>
            <fieldset>
              <legend class="cdk-visually-hidden">{{context.facetSchema.blockName}}</legend>
              <ul class="filters-list">
                <li *ngFor="let facet of facetResults.data; trackBy: trackById"
                    class="facet-line"
                    [class.facet-line-with-lock]="facet.selected"
                >
                  <ng-container *ngIf="facet.selected">
                    <button class="facet-lock"
                      (click)="onToggleBubbleLock(facet)"
                      [attr.aria-label]="'Lock ' + facet.label + ' facet'"
                      attr.aria-pressed="{{ facet.isResetLocked }}"
                      data-automation-id="modal-window-facets-lock-btn">
                      <span [ngClass]="facet.isResetLocked ? 'icon-lock' : 'icon-lock-open'"></span>
                    </button>
                  </ng-container>
                  <ins-bs-checkbox class="facet-checkbox"
                                   [checked]="selected(facet)"
                                   [containerClass]="['mx-1']"
                                   [ngClass]="{'selected': facet.selected}"
                                   (change)="onChange($event.checked, facet)"
                                   [aria-label]="facet.label + ' ' + facet.count"
                                   [tippy]="facet.label"
                                   data-automation-id="facet-checkbox">
                  </ins-bs-checkbox>
                  <span class="facet-label" data-automation-id="facet-label">
                    {{ facet.label }}
                  </span>
                  <div data-automation-id="facet-count" class="facet-count">
                    <span>{{facet.count}}</span>
                  </div>
                </li>
              </ul>
            </fieldset>
          </div>
        </div>
      </div>
    </perfect-scrollbar>

    <div class="modal-footer justify-content-start">
      <button
        data-automation-id="facet-modal-confirm-button"
        aria-label="Confirm"
        (click)="onConfirm()"
        translate
        class="ins-buttons button-primary flint">confirmButton
      </button>
      <button (click)="activeModal.close()"
        data-automation-id="facet-modal-cancel-button"
        aria-label="Cancel"
        class="ins-buttons button-secondary flint ml-3"
        translate>cancelButton
      </button>
    </div>
  </div>
</div>
